"use strict";

import { swiper1, swiper2 } from "./swiper";
import { map } from "./map";
import { handleSubmit } from "./form";

document.getElementById("form").addEventListener("submit", handleSubmit);